export enum AlertType {
  Success = 'success',
  Error = 'error',
  Information = 'information',
  Warning = 'warning',
  SuccessBold = 'success-bold',
  ErrorBold = 'error-bold',
}
